var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { getLabelSx } from '@revdotcom/vaporwave-sx';
/**
 * The Label component should be applied automatically to elements that need it.
 *
 * This component is not exposed to external users of vaporwave.
 */
export var Label = function (_a) {
    var color = _a.color, fontWeight = _a.fontWeight, fontSize = _a.fontSize, _b = _a.variant, variant = _b === void 0 ? 'uppercase' : _b, _c = _a.necessityIndicator, necessityIndicator = _c === void 0 ? 'icon' : _c, _d = _a.isRequired, isRequired = _d === void 0 ? false : _d, children = _a.children, className = _a.className, rest = __rest(_a, ["color", "fontWeight", "fontSize", "variant", "necessityIndicator", "isRequired", "children", "className"]);
    return (_jsx("label", __assign({ className: className }, rest, { sx: getLabelSx(variant, necessityIndicator, isRequired, fontWeight, fontSize, color), children: children })));
};
